export default "/048cb1f2b29308e18768c65cfd51e426596a830c/89a905b293692b6c3482c1f38a6975ca.png";